import { render } from "./HostUpdate.vue?vue&type=template&id=aab3cd8a&scoped=true"
import script from "./HostUpdate.vue?vue&type=script&lang=js"
export * from "./HostUpdate.vue?vue&type=script&lang=js"

import "./HostUpdate.vue?vue&type=style&index=0&id=aab3cd8a&scoped=true&lang=less"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab3cd8a"]])

export default __exports__